'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Editable = require('apollo-cms/lib/DataView/Object/Editable');

var _Editable2 = _interopRequireDefault(_Editable);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _materialUi = require('material-ui');

var _editor = require('@prisma-cms/editor');

var _editor2 = _interopRequireDefault(_editor);

var _Publish = require('material-ui-icons/Publish');

var _Publish2 = _interopRequireDefault(_Publish);

var _Done = require('material-ui-icons/Done');

var _Done2 = _interopRequireDefault(_Done);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var styles = function styles(theme) {
  return {
    root: {}
  };
};

var AccountView = (_temp = _class = function (_EditableView) {
  _inherits(AccountView, _EditableView);

  function AccountView() {
    _classCallCheck(this, AccountView);

    return _possibleConstructorReturn(this, _EditableView.apply(this, arguments));
  }

  AccountView.prototype.canEdit = function canEdit() {
    // const {
    //   user: currentUser,
    // } = this.context;
    // const {
    //   id: currentUserId,
    //   sudo,
    // } = currentUser || {};
    // const {
    //   id,
    //   CreatedBy,
    // } = this.getObjectWithMutations() || {};
    // const {
    //   id: createdById,
    // } = CreatedBy || {}
    // return !id || (createdById && createdById === currentUserId) || sudo === true;
    return false;
  }; // save() {
  //   const {
  //     user: currentUser,
  //     openLoginForm,
  //   } = this.context;
  //   if (!currentUser) {
  //     return openLoginForm();
  //   }
  //   return super.save();
  // }


  AccountView.prototype.getCacheKey = function getCacheKey() {
    var _ref = this.getObject() || {},
        id = _ref.id;

    return 'account_' + (id || "new");
  };

  AccountView.prototype.getButtons = function getButtons() {
    var buttons = _EditableView.prototype.getButtons.call(this) || [];

    var _ref2 = this.getObjectWithMutations() || {},
        id = _ref2.id,
        address = _ref2.address;

    var canEdit = this.canEdit();

    if (canEdit && id) {
      if (address) {
        buttons.push(_react2.default.createElement(_Done2.default, {
          key: 'done',
          color: 'green'
        }));
      } else {
        buttons.push(_react2.default.createElement(_materialUi.IconButton, {
          key: 'deploy'
        }, _react2.default.createElement(_Publish2.default, null)));
      }
    }

    return buttons;
  };

  AccountView.prototype.renderDefaultView = function renderDefaultView() {
    var Grid = this.context.Grid;
    var classes = this.props.classes;
    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var accountId = object.id,
        description = object.description,
        source = object.source,
        address = object.address,
        balance = object.balance,
        Accounts = object.Accounts;
    var inEditMode = this.isInEditMode();
    var canEdit = this.canEdit();
    return _react2.default.createElement(Grid, {
      container: true,
      spacing: 8
    }, address ? _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement('a', {
      href: 'https://etherscan.io/address/' + address,
      target: '_blank',
      rel: 'nofollow'
    }, address)) : null, description ? _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement(_materialUi.Typography, {
      color: 'textSecondary'
    }, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"), _react2.default.createElement(_editor2.default, {
      value: description
    })) : null, _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement('table', null, _react2.default.createElement('tbody', null, _react2.default.createElement('tr', null, _react2.default.createElement('th', null, "\u0411\u0430\u043B\u0430\u043D\u0441 Eth"), _react2.default.createElement('td', null, balance))))), _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement(Grid, {
      container: true,
      spacing: 16
    }, Accounts && Accounts.length ? _react2.default.createElement(Grid, {
      item: true
    }, _react2.default.createElement(_materialUi.Typography, {
      color: 'textSecondary'
    }, "\u041E\u043F\u0443\u0431\u043B\u0438\u043A\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u044B"), Accounts.map(function (n) {
      var id = n.id,
          createdAt = n.createdAt,
          address = n.address,
          CreatedBy = n.CreatedBy;

      if (!address) {
        return address;
      }

      return _react2.default.createElement(_materialUi.Typography, {
        key: id
      }, (0, _moment2.default)(createdAt).format('lll'), ' ', _react2.default.createElement('a', {
        href: 'https://etherscan.io/address/' + address,
        target: '_blank'
      }, address));
    })) : null)));
  };

  AccountView.prototype.renderEditableView = function renderEditableView() {
    var _this2 = this;

    var Grid = this.context.Grid;
    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var accountId = object.id,
        description = object.description,
        source = object.source;
    return _react2.default.createElement(Grid, {
      container: true,
      spacing: 8
    }, _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, this.getTextField({
      name: "name",
      label: "Название контракта"
    })), _react2.default.createElement(Grid, {
      item: true,
      xs: 12
    }, _react2.default.createElement(_materialUi.Typography, {
      color: 'textSecondary'
    }, "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"), this.getTextField({
      name: "description",
      label: "Описание контракта",
      Editor: _editor2.default,
      readOnly: false,
      value: description || null,
      onChange: function onChange(description) {
        return _this2.updateObject({
          description: description
        });
      }
    })));
  };

  AccountView.prototype.renderResetButton = function renderResetButton() {
    var _ref3 = this.getObjectWithMutations() || {},
        id = _ref3.id;

    return id ? _EditableView.prototype.renderResetButton.call(this) : null;
  };

  AccountView.prototype.render = function render() {
    if (typeof window === "undefined") {
      return null;
    }

    var object = this.getObjectWithMutations();

    if (!object) {
      return null;
    }

    var classes = this.props.classes;
    return _react2.default.createElement('div', {
      className: classes.root
    }, _EditableView.prototype.render.call(this));
  };

  return AccountView;
}(_Editable2.default), _class.propTypes = _extends({}, _Editable2.default.propTypes, {
  classes: _propTypes2.default.object.isRequired
}), _class.defaultProps = _extends({}, _Editable2.default.defaultProps), _temp);
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(AccountView, props);
});
module.exports = exports['default'];